import service from '@/config/axios'

/**
 * 首页相关接口
 */

// 获取首页Banner配置
const getHomepageConfig = () => {
  return service.get('/api/home/config',{ rawResponse: true })
}

// 更新首页Banner配置（后台管理）
const updateHomepageConfig = (data) => {
  return service.post('/api/home/config/update', data)
}

// 获取首页四个分类及产品列表
const getHomepageCategories = (top = 8) => {
  return service.get('/api/home/homepage-categories', { params: { top }, rawResponse: true })
}

export {
  getHomepageConfig,
  updateHomepageConfig,
  getHomepageCategories
}